export default {
  Dialog: "Dialog",
  System: "System",
  Errors: "Errors",
  Search: "Search",
  Settings: "Settings",
};
